require('./contractAresLoanStep1.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');
//@components
const ContractLoanTooltip = require('../../contractLoanTooltip/contractLoanTooltip');
const ContractLoanAccounts = require('../../contractLoanAccounts/contractLoanAccounts');
// @constants
const translations = require('./contractAresLoanStep1.translations');
const dossierStatus = require('../../../../loansConstants/dossierStatus');
const paymentDayTypes = require('../../../../loansConstants/paymentDayType');
const { BLOCKED_ACCOUNTS_CONTRACT_PAYROLL_LOAN } = require('constants/operationCodesAccounts');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
const { formatPercentage, getFormattedString, formatCurrency, decimalsLength } = require('utilities/currencyHelper');
const { mapContractingData, mapTotalCostInfo } = require('../contractAresLoanHelper');
//@analytics
const { analyticsId, catalogue } = require('../analytics/contractAresLoanAnalytics');
class ContractAresLoanStep1 extends React.Component {
    constructor(props) {
        super(props);
    }

    buildTaeTooltip() {
        const { immAresDossier, paymentDayType } = this.props;

        return (
            <ContractLoanTooltip
                immContractLoan={mapContractingData(immAresDossier.get('dossier').get('contractingData'), paymentDayType)}
                clarifyingText="clarifyingText"
            />
        );
    }

    buildWaffer() {
        const { immAresDossier, paymentDayType } = this.props;
        const contractingData = mapContractingData(immAresDossier.get('dossier').get('contractingData'), paymentDayType);

        const installment = getFormattedString(contractingData.get('installment'));
        const tin = formatPercentage(contractingData.get('tin'));
        const tae = formatPercentage(contractingData.get('tae'));
        const totalAmount = getFormattedString({
            amount: contractingData.get('totalAmount'),
            currency: contractingData.get('currency'),
            decimalsLength: decimalsLength(contractingData.get('totalAmount')),
        });
        const arrangementPercentage = contractingData.get('arrangementPercentage');
        const arrangementFee = contractingData.get('arrangementFee');
        const currency = formatCurrency(contractingData.get('currency'));
        const taeTooltipInfo = this.buildTaeTooltip();
        const totalAmountTooltipInfo = formatText(translations.TOTAL_AMOUNT_TOOLTIP, [mapTotalCostInfo(immAresDossier.get('dossier').get('contractingData'), paymentDayType)]);

        const values = [
            {
                title: formatText(translations.TIN_LABEL),
                boldTitle: true,
                bodyText: tin,
                className: 'title-bold',
            }, {
                title: formatText(translations.TAE_LABEL),
                boldTitle: true,
                bodyText: tae,
                icon: 'icon-informacion',
                tooltipPlacement: 'right',
                tooltipModifier: 'dark-bg',
                tooltipAlternativeIcon: true,
                tooltipClassName: 'contract-ares-loan-step-one__tooltip',
                iconCustomClass: 'contract-ares-loan-step-one__tae-icon',
                tooltipOffset: [10, 0],
                className: 'title-bold item-compact item-tae',
                information: taeTooltipInfo,
                onTooltipClick: ()=> recordLinkV2(catalogue[analyticsId.CLICK_TOOLTIP_TAE]()),
            }, {
                title: formatText(translations.OPENING_FEE_LABEL, [arrangementPercentage]),
                boldTitle: true,
                bodyText: `${arrangementFee} ${currency}`,
                additionalLabel: (<sup>1</sup>),
                className: 'title-bold',
            }, {
                title: formatText(translations.TOTAL_AMOUNT_LABEL),
                boldTitle: true,
                bodyText: totalAmount,
                icon: 'icon-informacion',
                tooltipPlacement: 'right',
                tooltipModifier: 'dark-bg',
                tooltipAlternativeIcon: true,
                tooltipClassName: 'contract-ares-loan-step-one__tooltip',
                iconCustomClass: 'contract-ares-loan-step-one__tae-icon',
                tooltipOffset: [10, 0],
                className: 'title-bold item-compact',
                information: totalAmountTooltipInfo,
                onTooltipClick: ()=> recordLinkV2(catalogue[analyticsId.CLICK_TOOLTIP_TOTAL_AMOUNT]()),
            }
        ];

        return (
            <div className="contract-ares-loan-step-one__waffer">
                <OKCalculationWaffer
                    itemsList={values}
                    outstandedLabel={formatText(translations.INSTALLMENT_LABEL)}
                    outstandedText={installment}
                />
            </div>
        );
    }

    buildAccounts() {
        const {
            immAccounts,
            selectedAccount,
            setSelectedAccount,
            getBlockedAccounts,
            immFlagBasedFeatures
        } = this.props;
        
        const disclaimer = {
            warning: 'contractPayrollLoanStepOne-contractPayrollLoanStepOne_blockedAccountsWarning',
            important: 'contractPayrollLoanStepOne-contractPayrollLoanStepOne_blockedAccountsImportant'
        };
        const errorMsgSelectedAccount = formatText('contractPayrollLoanStepOne-contractPayrollLoanStepOne_errorMsgSelectedAccount');

        return (
            <ContractLoanAccounts
                blockedAccountsContract={BLOCKED_ACCOUNTS_CONTRACT_PAYROLL_LOAN}
                disclaimer={disclaimer}
                getBlockedAccounts={getBlockedAccounts}
                immAccounts={immAccounts}
                immFlagBasedFeatures={immFlagBasedFeatures}
                setSelectedAccount={setSelectedAccount}
                selectedAccount={selectedAccount}
                errorSelectedAccount={false}
                errorMsgSelectedAccount={errorMsgSelectedAccount}
            />
        );
    }

    buildInformativeText(key, id = "") {
        return (
            <div className="contract-ares-loan-step-one__margin-bottom">
                <OKMessage type="informative" id={id} >
                    <FormattedText value={key} />
                </OKMessage>
            </div>
        );
    }

    buildPaymentDayTypeSelector() {
        const { paymentDayType, setPaymentDateType } = this.props;
        const today = new Date(Date.now()).getDate();

        return (
            <RadioButtonGroup
                label={formatText(translations.PAYMENT_DAY_TYPE_TITLE)}
                onChange={setPaymentDateType}
                name="contract-ares-day-selector"
                idPrefix="contract-ares-day-selector"
                selectedValue={paymentDayType}
            >
                <RadioButton label={formatText(translations.PAYMENT_DAY_TYPE_END_MONTH)} value={paymentDayTypes.END_OF_MONTH} />
                <RadioButton label={formatText(translations.PAYMENT_DAY_TYPE_ANNIVERSARY, [today])} value={paymentDayTypes.ANNIVERSARY} />
            </RadioButtonGroup>
        );
    }

    render() {
        const { immAresDossier } = this.props;
        
        if (immAresDossier.get('isFetching')) return <LoadingSection />;

        const dossier = immAresDossier.get('dossier');
        const isApproved = dossier.get('status') === dossierStatus.APPROVED;
        const waffer = this.buildWaffer();
        const accountsSelector = this.buildAccounts();
        const paymentDayType = this.buildPaymentDayTypeSelector();
        const taeMessage = this.buildInformativeText(translations.TAE_MESSAGE);
        const personalDataMessage = this.buildInformativeText(translations.PERSONAL_DATA_MESSAGE, "personalDataInformation");
        const link = document.getElementById("personalDataInformation");
        if (link) {
            link.onclick = () => recordLinkV2(catalogue[analyticsId.CLICK_RIGHTS_AND_DATA_PROTECTION_LINK]());
        }

        return (
            <section className="contract-ares-loan-step-one">
                <div className="contract-ares-loan-step-one__title">
                    <FormattedText value={translations.TITLE} />
                </div>
                <p className="contract-ares-loan-step-one__subtitle">
                    <FormattedText
                        value={isApproved ? translations.DESCRIPTION_APPROVED_01 : translations.DESCRIPTION_COUNTEROFFER_01}
                    />
                </p>
                <p className="contract-ares-loan-step-one__subtitle contract-ares-loan-step-one__bold">
                    <FormattedText
                        value={isApproved ? translations.DESCRIPTION_APPROVED_02 : translations.DESCRIPTION_COUNTEROFFER_02}
                        injectedStrings={[ dossier.get('contractingData').get('amount'), dossier.get('contractingData').get('term') ]}    
                    />
                </p>
                <div className="contract-ares-loan-step-one__separator"></div>
                {waffer}
                <div className="contract-ares-loan-step-one__margin-bottom">
                    {accountsSelector}
                </div>
                <div className="contract-ares-loan-step-one__margin-bottom">
                    {paymentDayType}
                </div>
                {taeMessage}
                {personalDataMessage}
            </section>
        );
    }
}

ContractAresLoanStep1.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    // Dossier Reducer
    immAresDossier: PropTypes.object.isRequired,
    // payment day type
    paymentDayType: PropTypes.string.isRequired,
    setPaymentDateType: PropTypes.func.isRequired,
    // accounts
    selectedAccount: PropTypes.string,
    setSelectedAccount: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
};

module.exports = ContractAresLoanStep1;
